import type { Components } from '@mui/material/styles';

import {
  iconSizeLarge,
  iconSizeMedium,
  iconSizeSmall,
  iconSizeXSmall,
  largeSize,
  mediumSize,
  smallSize,
  xSmallSize,
} from '@/mui/components/constants';

export default function MUIIconButton(): Components['MuiIconButton'] {
  return {
    defaultProps: {
      color: 'neutral',
    },
    styleOverrides: {
      root: {
        padding: 0,
      },
      sizeLarge: {
        fontSize: iconSizeLarge,
        width: largeSize,
        height: largeSize,
      },
      sizeMedium: {
        fontSize: iconSizeMedium,
        width: mediumSize,
        height: mediumSize,
      },
      sizeSmall: {
        fontSize: iconSizeSmall,
        width: smallSize,
        height: smallSize,
      },
      sizeXSmall: {
        fontSize: iconSizeXSmall,
        width: xSmallSize,
        height: xSmallSize,
      },
    },
  };
}
